import React from 'react';
import ListItem from 'housecall-ui/dist/DesignSystem/DataDisplay/List/ListItem';
import ListItemText from 'housecall-ui/dist/DesignSystem/DataDisplay/List/ListItemText';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Link from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link';

import TrackedSubmit from 'components/Common/Inputs/Buttons/TrackedSubmit';

export interface ListItemProps {
  title: string;
  supportive_display: string;
  redirectUrl: string;
  [key: string]: string;
}

const SearchListItem = ({ item }: { item: ListItemProps }) => (
  <TrackedSubmit
    submitComponent={ListItem}
    buttonName="search drawer result"
    submittedValue={item.object_type}
    component={Link}
    href={item.redirectUrl}
    onSubmit={() => undefined}
    rel="noopener noreferrer"
    color="secondary"
    underline="none"
    button
  >
    <Grid container>
      <Grid item xs={8}>
        <ListItemText>
          <Typography variant="body1" noWrap>
            {item.title}
          </Typography>
        </ListItemText>
      </Grid>
      <Grid item xs={4}>
        <ListItemText>
          <Typography variant="body1" color="textSecondary" noWrap>
            {item.supportive_display}
          </Typography>
        </ListItemText>
      </Grid>
    </Grid>
  </TrackedSubmit>
);

export default SearchListItem;
